import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { NoteTypeSummaryResponse } from '../../../../models/report.model';
import { CLPUser, ClpUsersDdResponse, UserResponse } from '../../../../models/clpuser.model';
import { eFeatures, eReportTimeType, eUserRole } from '../../../../models/enum.model';
import { RoleFeaturePermissions } from '../../../../models/roleContainer.model';
import { ReportService } from '../../../../services/report.service';
import { LocalService } from '../../../../services/shared/local.service';
import { UtilityService } from '../../../../services/shared/utility.service';
import { AccountSetupService } from '../../../../services/accountSetup.service';
import { IntDropDownItem } from '../../../../models/genericResponse.model';
import { GridConfigurationService } from '../../../../services/shared/gridConfiguration.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
declare var $: any;
@Component({
    selector: 'app-note-type-summary',
    templateUrl: './note-type-summary.component.html',
    styleUrls: ['./note-type-summary.component.css'],
    providers: [GridConfigurationService]
})
export class NoteTypeSummaryComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    noteTypeSummaryListSource: MatTableDataSource<any>;
    @ViewChild('pdfExport') pdfExport!: PDFExportComponent;
    noteTypeSummaryListDisplayColumns: string[];
    showSpinner: boolean = false;
    roleFeaturePermissions: RoleFeaturePermissions;
    user: CLPUser;
    private encryptedUser: string = '';
    userResponse: UserResponse;

    columns = [];
    noteTypeSummaryList: {}[];
    userList: IntDropDownItem[];
    spanTitleText: string;
    noteTypeSummaryForm: FormGroup;
    mobileColumnNames: string[];
    eUserRole = eUserRole;
    reorderColumnName: string = '';
    columnWidth: string = '';
    arrColumnWidth: any[] = []
    exporting: boolean;
    reloadGrid: boolean = true;
    constructor(private fb: FormBuilder,
        private datepipe: DatePipe,
        private _reportService: ReportService,
        private _accountSetupService: AccountSetupService,
        public _localService: LocalService,
        private _utilityService: UtilityService,
        public _gridCnfgService: GridConfigurationService,
        private _router: Router) {
        this._localService.isMenu = true;
    }

    ngOnInit(): void {
        this.noteTypeSummaryForm = this.prepareNoteTypeSummaryForm();
        if (!isNullOrUndefined(localStorage.getItem("token"))) {
            this.encryptedUser = localStorage.getItem("token");
            this.authenticateR(() => {
                if (!isNullOrUndefined(this.user)) {
                    this.getLoadUsers();
                    this.getNoteTypeSummaryList();
                }
                else
                    this._router.navigate(['/login']);
            })
        }
        else
            this._router.navigate(['/login']);
    }

    private async authenticateR(callback) {
        await this._localService.authenticateUser(this.encryptedUser, eFeatures.NoteTypeSummary)
            .then(async (result: UserResponse) => {
                if (result) {
                    this.userResponse = UtilityService.clone(result);
                    if (!isNullOrUndefined(this.userResponse)) {
                        if (!isNullOrUndefined(this.userResponse?.user)) {
                            this.user = this.userResponse.user;
                            this.roleFeaturePermissions = this.userResponse.roleFeaturePermissions;
                            this.noteTypeSummaryForm.controls.ddUser.setValue(this.user?.cLPUserID);
                            if (this.user?.userRole <= eUserRole.Administrator) {
                                if (this.roleFeaturePermissions?.view == false)
                                    this._router.navigate(['/unauthorized'], { state: { isMenu: true } });
                            }
                        }
                    }
                }
                this.showSpinner = false;
            }).catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
        callback();
    }

    prepareNoteTypeSummaryForm() {
        return this.fb.group({
            date: new FormControl(new Date(), [Validators.required]),
            ddUser: new FormControl(),
            type: new FormControl(eReportTimeType.Day)
        });
    }

    async getLoadUsers() {
        await this._accountSetupService.getClpUserList(this.encryptedUser, this.user?.cLPCompanyID)
            .then(async (result: ClpUsersDdResponse) => {
                if (!isNullOrUndefined(result))
                    this.userList = UtilityService.clone(result?.clpUsers);
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getNoteTypeSummaryList() {
        this.showSpinner = true;
        this.reloadGrid = false;
        const date = this.datepipe.transform(this.noteTypeSummaryForm.controls.date.value, 'MMddyyyy');
        const ddUser = !isNullOrUndefined(this.noteTypeSummaryForm.controls.ddUser.value) ? this.noteTypeSummaryForm.controls.ddUser.value : this.user.cLPUserID;
        await this._reportService.getNoteTypeSummaryList(this.encryptedUser, this.user.cLPCompanyID, ddUser, date ? date : '', this.noteTypeSummaryForm.controls.type.value)
            .then(async (result: NoteTypeSummaryResponse) => {
                if (result) {
                    const response = UtilityService.clone(result);
                    this.noteTypeSummaryList = response?.noteTypeSummaryList;
                    this.spanTitleText = response?.spanTitleText;
                    if (this.noteTypeSummaryList?.length > 0) {
                        this.columns = await this._localService.createDynamicGridColoumn(this.noteTypeSummaryList[0]);
                        this.reloadGrid = true;
                        this.setGrid(this.noteTypeSummaryList);
                        //this.reorderColumnName = this._localService.createDynamicGridReorderColoumn(this.noteTypeSummaryList[0]);
                    }
                    this.mobileColumnNames = this._localService.mobileDefaultColoumnConfig();
                    //Kendo grid load call stopped.
                    //this.getGridConfiguration()

                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this.showSpinner = false;
                this._utilityService.handleErrorResponse(err);
            });
    }

    public saveExcel(component): void {
        this._localService.saveExcel(component, 'Note Type Summary');
    }

    //getGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.user = this.user;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'note_type_summary_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('note_type_summary_grid').subscribe((value) => { }));
    //}

    //resetGrid() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'note_type_summary_grid').subscribe((value) => this.getGridConfiguration());
    //}

    setGrid(list) {
        this.noteTypeSummaryListDisplayColumns = this.columns.map(c => c.field);
        this.noteTypeSummaryListSource = new MatTableDataSource(list);
        this.addTimeout(() => {
            this.noteTypeSummaryListSource.paginator = this.paginator;
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('note_type_summary_grid') ? this._localService.getPageSize('note_type_summary_grid'): 50;
            }
            this.noteTypeSummaryListSource.sort = this.sort;
            const sortState: Sort = this._localService.getSortState('note_type_summary_grid');
            this.sort.active = sortState?.active;
            this.sort.direction = sortState?.direction;
            this.sort.sortChange.emit(sortState);
        }, 500)
    }

    exportPDF() {
        this.exporting = true;
        this.addTimeout(() => {
            this.pdfExport.saveAs('NoteTypeSummary.pdf')
        }, 100);
        this.addTimeout(() => { this.exporting = false }, 500);
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
